export const freewave2 = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber',
    'Steel Spoiler Design for Clear Vision during High-Speed Driving',
  ],
  'material': [
    'Rubber: Premium Nature Rubber',
    'Steel: SGCC, Electrostatic Powder Coating',
    'Rivet: SUS302',
    'Plastic: Spacer & Adapter: POM, Spoiler: ABS',
    'Stainless Steel Backing: 304ES',
  ],
  'featureIcons': ["02", "03", "05"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "18", "mm": "450", "claw": "6", "width": "6", "thickness": "1.2" },
    { "inch": "19", "mm": "475", "claw": "6", "width": "6", "thickness": "1.2" },
    { "inch": "20", "mm": "500", "claw": "6", "width": "6", "thickness": "1.2" },
    { "inch": "21", "mm": "530", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "22", "mm": "560", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "23", "mm": "575", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "24", "mm": "600", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "26", "mm": "650", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "28", "mm": "700", "claw": "8", "width": "8", "thickness": "1.2" }
  ],
  'adapters': ["a7", "b", "c", "b1", "b3", "b6", "c1", "d2", "d4", "f", "g1", "pc", "s", "s1", "f3"]
}
